<ng-template #defaultTabButtons let-c="close" let-d="dismiss">

    <div class="backgroundTable text-white" ngbAutofocus>

        <div class=" mx-5 ">
            <div class="row my-2">
              <div class="col-9 align-self-center p-2 bd-highlight ">Información</div>
    
              <div class="col-3 d-flex flex-row-reverse bd-highlight p-2 "><button type="button" ngbAutofocus aria-label="Close"  (click)="d('Cross click')" class="btn btn-outline-danger "><i class="fa-solid fa-xmark fa-xl"></i></button></div>
            </div>
          </div>
        <div class="componente-importantes-from  componente-importantes-from-popup">

            <div class="row justify-content-md-center pb-5">
                <div class="col-md-auto">
                    {{summaryInfoDto.title}}
                </div>
            </div>

            <div class="row justify-content-md-left ms-5 pb-4">
                <div class="col-md-auto badge rounded-pill text-bg-creado">
                    {{summaryInfoDto.info}}
                </div>
                <div class="col-md-auto badge rounded-pill text-bg-pendiente">
                    {{summaryInfoDto.stado}}
                </div>
                <div class="col-md-auto badge rounded-pill text-bg-programado">
                    Grupo: {{summaryInfoDto.group}}
                </div>
            </div>

            <div class="container px-5 pb-5">
                <div class="backgroundTable">

                    <div class="row">
                        <div class="col-6 filterDatatable">
                            <div class="col-md-6 text-left ms-4 mt-3">
                                <span><i class="fa-solid fa-users  fa-lg"></i> Equipo asignado</span>
                            </div>
                        </div>
                    </div>

                    <table *ngIf="summaryInfoDto.listAssigned != null && summaryInfoDto.listAssigned.length != 0" datatable [dtOptions]="dtOptions"
                        class="componente-importantes componente-importantes-from-popup">

                        <ng-container *ngIf="summaryInfoDto.listAssigned != null && summaryInfoDto.listAssigned.length == 0">
                            <div class="text-center text-white">
                                <h2 class="text-white px-5 mt-5">Sin Registro</h2>
                                <i class="fa-solid fa-face-sad-cry fa-5x my-3"></i>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="summaryInfoDto.listAssigned.length != 0">
                            <thead>
                                <tr>
                                    <th class="text-white text-center">Nombre</th>
                                    <th class="text-white text-center">% Asignación</th>
                                    <th class="text-white text-center">Rol</th>
                                    <th class="text-white text-center">Fecha Inicio</th>
                                    <th class="text-white text-center">Fecha Fin</th>
                                    <th class="text-white text-center">Estado Asignado</th>
                            </thead>

                            <tbody>
                                <tr *ngFor="let item of summaryInfoDto.listAssigned">
                                    <td class="text-center">{{item.name}}</td>
                                    <td >
                                        <div class="p-2 bd-highlight d-flex flex-column">
                                          <span class="badge rounded-pill text-bg-pendiente p-2 " style="font-size: 12px;">{{item.percentage}} %</span>
                                        </div>
                    
                                    </td>
                                    <td class="text-center">{{item.type}}</td>
                                    <td class="text-center">{{item.dateStart}}</td>
                                    <td class="text-center">{{item.dateEnd}}</td>
                                    <td >
                                        <div class="p-2 bd-highlight d-flex flex-column">
                                            <span *ngIf="item.status == 1"
                                              class="badge rounded-pill text-bg-pagado p-2 " style="font-size: 12px;">{{item.typeStatus}}</span>
                                           <span *ngIf="item.status == 2"
                                              class="badge rounded-pill text-bg-creado p-2 " style="font-size: 12px;">{{item.typeStatus}}</span>
                                        </div>
                    
                                    </td>
                                </tr>
                            </tbody>
                        </ng-container>
                    </table>

                </div>
            </div>



            <div class="container px-5 pb-5">
                <div class="backgroundTable">

                    <div class="row">
                        <div class="col-6 filterDatatable">
                            <div class="col-md-6 text-left ms-4 mt-3">
                                <span><i class="fa-solid fa-dollar-sign fa-lg"></i> Pagos</span>
                            </div>
                        </div>
                    </div>

                    <table *ngIf="summaryInfoDto.listMoney != null && summaryInfoDto.listMoney.length != 0" datatable [dtOptions]="dtOptions"
                        class="componente-importantes componente-importantes-from-popup">

                        <ng-container *ngIf="summaryInfoDto.listMoney != null &&  summaryInfoDto.listMoney.length == 0">
                            <div class="text-center text-white">
                                <h2 class="text-white px-5 mt-5">Sin Registro</h2>
                                <i class="fa-solid fa-face-sad-cry fa-5x my-3"></i>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="summaryInfoDto.listMoney.length != 0">
                            <thead>
                                <tr>
                                    <th class="text-white text-center">Detalle</th>
                                    <th class="text-white text-center">Cantidad</th>
                                    <th class="text-white text-center">Porcentaje</th>
                                    <th class="text-white text-center">Fecha pago</th>
                                    <th class="text-white text-center">Estado</th>
                            </thead>

                            <tbody>
                                <tr *ngFor="let item of summaryInfoDto.listMoney">
                                    <td class="text-center">{{item.description}}</td>
                                    <td class="text-center">{{item.type}} {{item.money}}</td>
                                    <td class="text-center">{{item.percentage}} %</td>
                                    <td class="text-center">{{item.date}}</td>
                                    <td >
                                        <div class="p-2 bd-highlight d-flex flex-column">
                                            <span *ngIf="item.status == 2"
                                              class="badge rounded-pill text-bg-programado p-2" style="font-size: 12px;">{{item.typeStatus}}</span>
                                            <span *ngIf="item.status == 3"
                                              class="badge rounded-pill text-bg-pagado p-2 " style="font-size: 12px;">{{item.typeStatus}}</span>
                                            <span *ngIf="item.status == 4"
                                              class="badge rounded-pill text-bg-anulado p-2 " style="font-size: 12px;">{{item.typeStatus}}</span>
                                            <span *ngIf="item.status == 5"
                                              class="badge rounded-pill text-bg-pendiente p-2 " style="font-size: 12px;">{{item.typeStatus}}</span>
                                            <span *ngIf="item.typeStatus === 'CREADO'"
                                              class="badge rounded-pill text-bg-creado p-2 " style="font-size: 12px;">{{item.typeStatus}}</span>
                                        </div>
                    
                                    </td>
                                </tr>
                            </tbody>
                        </ng-container>
                    </table>

                </div>
            </div>

        </div>
    </div>

</ng-template>